// this page is for adding categories
import React from 'react';
import Drawer from '@mui/material/Drawer';
import {TextField,Button,CircularProgress} from "@mui/material";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { toggleSnackbar,authVar} from "../../../ReactiveVariables/index";
import { useMutation } from '@apollo/client';
import { CREATE_CATEGORY,UPDATE_CATEGORY } from '../../../Graphql/mutations';
import {useNavigate } from "react-router-dom";
export default function AddCategories(props){
  const navigate = useNavigate()
    const schema = yup.object().shape({
        categoryTitle: yup.string().required("Category Title is required"),
      });
    const {
        register,
        handleSubmit,
        formState: { errors },
      } = useForm({ resolver: yupResolver(schema)});
      const [createCategory,{loading}] = useMutation(CREATE_CATEGORY,{refetchQueries:['ListCategory'],
    onCompleted:(res)=>{
        props?.setOpenCategory(false)
    }})
    const [updateCategory,{loading:updateLoading}] = useMutation(UPDATE_CATEGORY,{refetchQueries:['ListCategory'],
    onCompleted:(res)=>{
        props?.setOpenCategory(false)
    }})

    //add category functionality
      function onSubmit(params){
        params["_id"]= props?.selectedItem?._id
        try {
            props?.selectedItem?._id?updateCategory({variables: {id:props?.selectedItem?._id,data:params }}) 
            .then((res) => {
                toggleSnackbar({
                  status: true,
                  message: "Category updated successfully",
                  variant: 'success'
                });
              }).catch((err) => {
                const message = err && err.message;
                if(message==="Not authenticated"){
                  localStorage.clear();
                  authVar({
                    loaded: true,
                    auth: false,
                  });
                  navigate("/admin", { state: "noAuth" })
                }else{
                toggleSnackbar({
                  status: true,
                  message: message,
                  variant: "error",
                });
              }
              })
              :createCategory({ variables: {data:params } })
              .then((res) => {
                toggleSnackbar({
                  status: true,
                  message: "Category created successfully",
                  variant: 'success'
                });
              })
              .catch((err) => {
                const message = err && err.message
                if(message==="Not authenticated"){
                  localStorage.clear();
                  authVar({
                    loaded: true,
                    auth: false,
                  });
                  navigate("/admin", { state: "noAuth" })
                }else{
                toggleSnackbar({
                  status: true,
                  message: message,
                  variant: "error",
                });
              }
              });
            } catch (err) {
              const message = err && err.message;
              toggleSnackbar({
                status: true,
                message: message,
                variant: "error",
              });
            }
      }
    return (
        <Drawer className='common-drawer'
      anchor={"right"}
      open={props.openCategory}
      onClose={() => props.setOpenCategory(false)}
    >
       <div className='drawer-head'>
            <h4 className="h4"><img src="../assets/images/icon-contact-info.svg" className="img-fluid" alt="Contact Information Icon" />{props?.selectedItem?._id?"Edit Category":"Add Category"}</h4><span style={{ cursor: 'pointer' }} onClick={() => {props.setOpenCategory(false);props?.setSelectedItem(null)}}><img src="../assets/images/x-icon.svg" className="img-fluid" alt="close icon" /></span>
          </div>
          <form
          onSubmit={handleSubmit(onSubmit)}
          noValidate
          autoComplete="off"
        >
             <div className='create-step-form'>
          <div className='container-fluid'>
            <div className='textBox'> 
          <TextField
                  id="createAccountAdminName"
                  defaultValue={props?.selectedItem?.categoryTitle}
                  label="CATEGORY TITLE*"
                  autoFocus
                  variant="outlined"
                  className="textField allFeild"
                  {...register("categoryTitle")}
                />
                {errors.categoryTitle && <span className="error-msg">{errors.categoryTitle.message}</span>}
          </div>
          </div>
          </div>
          <div className="createStepBtn">
            <Button
              className="cancelBtn"
              variant="contained"
              color="secondary"
              onClick={() =>{ props.setOpenCategory(false);props?.setSelectedItem(null)}}
            >
              Cancel
            </Button>
            <Button
              className="saveBtn"
              variant="contained"
              type="submit"
              color="primary"
            >
              {loading||updateLoading ? <CircularProgress color="inherit" size={20} /> : props?.selectedItem?._id?"Update":"Add"}
            </Button>
          </div>
            </form>
        </Drawer>
    )
}